const customPrint = element => {
  //var printContents = element.innerHTML;
  //var originalContents = document.body.innerHTML;
  //document.body.innerHTML = printContents;

  //Need to update this to revert SVG file back to page
  while (document.querySelector("tr>th>span>svg")) {
    document.querySelector("tr>th>span>svg").remove();
  }

  const reportHeader = "<h2 align='center'>NTRAC Report</h2><hr/>";
  const newWin = window.open();
  newWin.document.write(reportHeader);
  newWin.document.write(element.outerHTML);
  newWin.print();
  newWin.close();

  //document.body.innerHTML = originalContents;
};

export default customPrint;



// WEBPACK FOOTER //
// ./src/utils/CustomPrint.js